import { AudienceOptions, SendOptions } from '../../../../../../modals/push-notifications/campaign/Constants';

export default {
  title: 'Criar Campanha de Notificação Push',
  sent_title: 'Notificação na fila',
  sent_subtitle:
    'A sua notificação push foi enviada para a Apple e Google. As confirmações de entrega chegam em cerca de 15 minutos.',
  sent_info_banner:
    'Pode fechar esta janela. Continuaremos a verificar e a atualizar as estatísticas de entrega da campanha automaticamente.',
  circles: {
    sent_label: 'Enviado',
    sent_sub: 'Enviado aos subscritores',
    delivered_label: 'Entregue',
    delivered_sub: 'A aguardar Apple & Google',
    delivered_ready_short: 'Pronto',
    delivered_ready_sub: 'Atualize para ver as estatísticas mais recentes',
  },
  scheduled_title: 'Campanha agendada',
  scheduled_body_line_1: 'A sua notificação push está agendada para {{when}}.',
  scheduled_body_line_2:
    'Será enviada automaticamente nesse momento. As confirmações de entrega da Apple e Google ficam disponíveis cerca de 15 minutos após o envio.',
  recipients_count_one: 'Enviado a {{count}} subscritor.',
  recipients_count_other: 'Enviado a {{count}} subscritores.',
  close: 'Fechar',
  sections: {
    message: 'Mensagem',
    audience: 'Audiência',
    when: 'Quando enviar',
    review: 'Revisão',
  },
  stepper: {
    message: 'Mensagem',
    audience_when: 'Quando enviar',
    review: 'Revisão',
  },
  blocked_reasons: {
    title_required: 'Adicione um título para continuar.',
    body_required: 'Adicione o corpo da mensagem para continuar.',
    offer_required: 'Selecione uma oferta para continuar.',
    promo_code_required: 'Selecione um código promocional para continuar.',
    send_option_required: 'Escolha quando enviar para continuar.',
    scheduled_at_required: 'Selecione uma data e hora para continuar.',
  },
  fields: {
    title: {
      label: 'Título',
      placeholder: 'Introduza o título da notificação',
    },
    body: {
      label: 'Corpo da Mensagem',
      placeholder: 'Introduza a sua mensagem',
    },
    audience: {
      label: 'Audiência',
    },
    send_options: {
      label: 'Opções de envio',
    },
    date_and_time: {
      label: 'Data & Hora',
      placeholder: 'Selecionar data & hora',
    },
  },
  send_options: {
    [SendOptions.Now]: 'Enviar Agora',
    [SendOptions.Schedule]: 'Agendar',
  },
  send_option_cards: {
    now: {
      title: 'Enviar agora',
      description: 'Enviar para todos os subscritores imediatamente.',
    },
    schedule: {
      title: 'Agendar',
      description: 'Selecione uma data e hora no futuro.',
    },
  },
  campaign_type_cards: {
    promotional: {
      title: 'Promocional 🚀',
      description: 'Promova uma oferta ou um código promocional.',
    },
    informational: {
      title: 'Informacional ℹ️',
      description: 'Partilhe novidades ou uma atualização — sem desconto associado.',
    },
  },
  audience: {
    [AudienceOptions.All]: 'Todos os utilizadores ({{count}} dispositivo)',
  },
  preview: {
    title: 'Pré-visualização',
    notifications: {
      title: 'O título da sua notificação aparecerá aqui',
      body: 'O corpo da sua mensagem será exibido aqui com todos os detalhes...',
      now: 'Agora',
    },
    estimated_reach: 'Alcance',
  },
  summary: {
    title: 'Resumo',
    reach: 'Alcance',
    when: 'Quando',
    campaign_type: 'Tipo de campanha',
    promo_code: 'Código promocional',
    offer: 'Oferta',
    test_audience: 'Envie primeiro um push de teste',
  },
  alerts: {
    daily_limit_reached: {
      title: 'Limite diário de envio atingido',
      description:
        'Atenção! Enviar mais de 1 notificação push por dia deixa os utilizadores insatisfeitos e pode levar à eliminação da app. Por isso, limitamos os pushes manuais a 1/dia. Por favor, agende este para amanhã.',
    },
    offer_not_sendable: {
      title: 'A oferta não está ativa hoje',
      description: 'Por favor, escolha uma data futura.',
    },
  },
  buttons: {
    send_now: 'Enviar Agora',
    save: 'Guardar',
    save_as_draft: 'Guardar como rascunho',
    send_test: 'Enviar Teste',
    draft_with_ai: 'Rascunho com IA',
    back: 'Voltar',
    next: 'Seguinte',
  },
  feedback: {
    success: 'Campanha guardada com sucesso',
    promo_code_expired: 'Código promocional expirado',
    error: 'Não foi possível guardar a campanha. Verifique a sua ligação e tente novamente.',
  },
};
